// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7d045a36","57":"4a98f248","60":"807bf02a","131":"e29dc0b3","163":"ef79ab4c","286":"f0013fd8","367":"aef7d463","437":"c4d4d680","457":"1ba2d388","515":"4d0fcd10","590":"beed3b08","622":"d6bd3360","799":"79608016","876":"b6ea3f68","915":"c1c9bc1b"}[chunkId] + ".chunk.js";
};